import React from 'react';
import MuiTable from '@mui/material/Table';
export function Table({ children, _sx, stickyHeader = false, size = 'medium', dataTestId, }) {
    return (React.createElement(MuiTable, { sx: _sx, stickyHeader: stickyHeader, size: size, "data-testid": dataTestId }, children));
}
